<template>
	<div id="panel-40" class="panel">
		<div class="panel-hdr bg-primary-500 bg-success-gradient">
			<h2>
				{{ __t('LIST') }} <span class="fw-300"><i>{{__t('cities')}}</i></span>
			</h2>
			<div class="panel-toolbar">


				<button class="btn btn-icon btn-sm btn-success mr-1 shadow-0 waves-effect waves-themed" v-on:click="create">
					<i class="fal fa-plus"></i>
				</button>

                <button class="btn btn-icon  btn-sm btn-danger mr-1 shadow-0 waves-effect waves-themed ml-2" v-on:click="remove_all">
                    <i class="fal fa-trash"></i>
                </button>

			</div>
		</div>
		<div class="panel-container show pt-1 pb-1">
			<div class="panel-content">
				<b-overlay :show="is_load" rounded="sm">
					<div class="rounded">
						<!-- nav-menu-reset will reset the font colors -->
						<ul class="nav-menu  mb-sm-4 mb-md-0 rounded " v-if="worked_cities.length > 0">
							<li v-for="city in worked_cities" :class="{
							'show_children' : city.children_show
						}">
								<a href="#" class="waves-effect waves-themed "
								   :class="{'active_filter':is_active_city(city),}">

									<strong class="dl-ref bg-success-500"
											v-on:click.self="setActive(city)"
											v-if="city.published">active</strong>

									<strong class="dl-ref bg-danger-500"
											v-on:click.self="setActive(city)"
											v-if="!city.published">active</strong>

									<span class="nav-link-text color-black" :class="{'text-muted': !city.is_upd}"
										  v-on:click.self="setActive(city)">

									<div>
										<div>
											{{ city.title }}
											<span class="small text-info">
												<i class="fal fa-lock" v-if="city.skeep_sync"></i>
											</span>
											<div class="small badge border border-warning text-black-50  mr-1">
												{{city.prov_name}}
											</div>

											<div class="mt-1" v-if="city.hasOwnProperty('visible_providers')">
												<div class="small badge border border-info  text-info mr-1"
													 v-for="prov in city.visible_providers"
													 v-if="prov.is_on"
												>
														{{ prov.human_name }}
												</div>
											</div>
											<!--
											<div class="uniq_id">
												<div class="small badge border border-info  text-info mr-1">
												{{city.uniq_id}}
											</div>
											</div>
											-->

										</div>
									</div>
								</span>
									<!--
									<b class="collapse-sign color-black" v-if="city.children.length > 0">
										<em class="fal fa-angle-down color-black children_info"
											v-on:click.stop="show_children(city)"></em>
									</b>
									-->

									<i class="fal fa-cog width-2 fs-xxl ml-4" v-on:click.stop="edit(city)"></i>
								</a>
								<!--
								<ul class="categ_bg" v-if="city.children.length > 0">
									<li :class="{'active':is_active_city(child)}" v-for="child in city.children"
										v-on:click.stop="setActive(child)">
										<a href="#" class=" waves-effect waves-themed">
										<span class="nav-link-text color-black">
											{{ child.title }}
										</span>
											<i class="fal fa-cog width-2 fs-xxl ml-4" v-on:click.stop="edit(child)"></i>
										</a>
									</li>
								</ul>
								-->
							</li>
						</ul>
						<div class="filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500"></div>
					</div>
				</b-overlay>
			</div>
		</div>

		<city_modal></city_modal>

	</div>
</template>

<script>


import City_modal from "./city_modal";
import axios from 'axios';
const request = axios.CancelToken.source();

import {createHelpers} from 'vuex-map-fields';
import {mapGetters} from "vuex";

export default {
	name: "cities",
	components: {City_modal},
	//components: {Categ_modal},
	data() {
		return {
			cities: [],
			is_load: true,
			is_show_modal: false,
            active_filter_city : [],
		}
	},

	created() {
		this.get_params();
		/*EventBus.$on('user_added',this.get_params)*/
		EventBus.$on('reload_cities',this.get_params)
	},


	methods: {
        remove_all() {
            let self = this;
            const is_ok = confirm_me(this.__t("ARE_SURE"));
            is_ok.then(res => {
                api.delete('/internal/v1/catalog/cities').then(({data}) => {
                    self.is_load = false;
                    if (data.status === "operation_success") {
                        EventBus.$emit('reload_cities');
                    }
                }).catch(({response}) => {
                    self.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message, type: "danger",
                        title: response.data.status,
                        position : "b-toaster-top-left"
                    })
                });
            });
        },

		create () {
			EventBus.$emit("city_edit", 0);
		},

		is_active_city(city) {
			let is_active = false;
			this.active_filter_city.map(id => {
				if (parseInt(id) === parseInt(city.id)) {
					is_active = true;
				}
			});

			return is_active;
		},

		edit(city) {
			EventBus.$emit("city_edit", parseInt(city.id));
		},

		show_children(city) {
			city.children_show = !city.children_show;
		},

		setActive(city) {

            const id = parseInt(city.id);
            if (this.active_filter_city.includes(id)) {
                this.active_filter_city = this.active_filter_city.filter(v => v !== id);
            } else {
                this.active_filter_city.push(id);
            }

            this.$emit('input', this.active_filter_city);
            EventBus.$emit('org_filter_changed', {
                "type": "cities",
                "value": this.active_filter_city
            });
		},

		async get_params() {
			this.cities = [];
			this.is_load = true;

			await axios.get('/internal/v1/catalog/cities').then(({data}) => {
				this.is_load = false;
				if (data.status === "operation_success") {
					this.cities = data.data;
					this.cities.map(item => {
						item.is_active = false;
					})

				} else {
					this.cities = [];
				}
			}).catch(({response}) => {
				this.is_load = false;
				this.cities = [];
				EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
			});
		}
	},

	computed: {
		...mapGetters({
			'user': "user/getUser",
		}),


		worked_cities() {
			return this.cities;
		},

		all_cities() {
			let res = [];
			this.cities.map(item => {
				res.push(item);
				/*if (item.children.length > 0) {
					item.children.map(child => {
						res.push(child);
					});
				}*/
			})

			return res;
		},
	}
}
</script>

<style scoped>
.categ_bg {
	background-color: #eeeeee2e;
}

.children_info {
	width: 15px;
	height: 15px;
	cursor: row-resize;
	text-align: center;
}

a.active_filter {
	border-left: 3px solid #584475;
	background: #eee;
}

li.show_children ul {
	display: block;
}

</style>
